import { SurveyFormValues } from '@/components/base/customer-survey/customer-survey';

export interface SurveyQuestion {
  type: 'radio' | 'textarea';
  name: keyof SurveyFormValues;
  options: string[];
  optional?: boolean;
}

export const SURVEY_QUESTIONS: SurveyQuestion[] = [
  {
    type: 'radio',
    name: 'achievement',
    options: ['yes', 'no'],
  },
  {
    type: 'radio',
    name: 'satisfaction',
    options: [
      'strongly_disagree',
      'disagree',
      'somewhat_disagree',
      'neutral',
      'somewhat_agree',
      'agree',
      'strongly_agree',
    ],
  },
  {
    name: 'feedback',
    type: 'textarea',
    options: [],
    optional: true,
  },
];
